module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoBAMAAAB+0KVeAAAAJ1BMVEUAAAAeHh4XFxcZGRkaGhoaGhoYGBgaGhoZGRkZGRkZGRkZGRkZGRl7+L/YAAAADHRSTlMAESIzRHeIqrvM3e6hc831AAAAXUlEQVQoz2OYcwYDnGQ46oIBYhiOMGAAn2EjKIxFkGWNA6ZgTCemoOVWDgxB1pMKGILMcwIYMARjJjNgCLIfYyBSEKt27BZhdRJ2x2P3JvYAwRp0wyWFYM0I2LIMAAM2YbtbwZIvAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/static/img/page_left_arrow.png
// module id = 255
// module chunks = 0